<template>
    <div>
    <div id="odpopa">
     <div class="title_left">{{ title }}</div>
     <div class="dokpz_left">
        <span class="allopak" v-on:click="allopakclick()">(pokaż wszystkie skrzynie)</span>

	<div class="items">
     		<ejs-grid ref="grid" :dataSource="data" :allowPaging="true" :pageSettings="pageSettings" :allowSorting="true" :allowGrouping="false" :selectionSettings="selectionOptions" :rowSelected='rowSelected' :rowDeselected="rowSelected"> 
			<e-columns>
				<e-column field='id_rodzaju_skrzyni' headerText='ID' :visible="false"></e-column>
				<e-column field='id_dokumentu_magazynowego' headerText='Id magazynu' :visible="false"></e-column>
				<e-column field='typ_skrzyni' headerText='Typ Skrzyni' width='200'></e-column>
				<e-column field='waga_skrzyni' headerText='Waga' width='100'></e-column>
				<e-column field='opis_skrzyni' headerText='Opis' width='200'></e-column>
            			<!--<e-column type='checkbox' width='50'></e-column>-->
			</e-columns>
		</ejs-grid>
	</div>
     </div>
     <div class="dokpz_right">
        <div v-for="(item,index) in data" :key="index">
                <Skrzynia :nazwa="item.rodzaj_opakowania" :ident="index" :skr="skr"/>
        </div>
	<div v-show="czywaga">
                <button class="do_wagi1"> 1 </button>
                <button class="do_wagi2"> 2 </button>
                <button class="do_wagi3"> 3 </button>
        </div>
      </div>
    </div>
    <div class="wbottom">
      <div class="wleft">
                <button class="wlabel"> WRÓĆ </button>
      </div>
      <div class="wright dokpz_right2">
        <div v-show="czywaga">
                <button class="wlabel do_wagi"> PRZEJDŹ DO WAGI </button>
        </div>
      </div>
     </div>
    </div>
</template>

<script>

import Vue from "vue";
import { GridPlugin, Page, Sort, Filter, Group } from "@syncfusion/ej2-vue-grids";
import { opakowanie_dane } from "./opakowanie_dane.js";
import Skrzynia from "@/components/Skrzynia";
import * as CONFIG from "./config.js";
import axios from "axios";
import Storage from "./Storage";

axios.defaults.withCredentials = false;

Vue.use(GridPlugin);
Vue.use(Skrzynia);

export default {
  name: "opakowanieskrzynie",
  props: {
    groupTitle: String,
    dataLoading: Boolean,
  },
  data: () => ({
	//data: opakowanie_dane.items,
	data: [],
	url: "/agent/GALEK.Magazyn/GetSkrzynie",
	title: "Podaj opakowanie",
	show: false,
        pageSettings: { pageSize: 10 },
        selectionOptions: { allowColumnSelection: false, type: 'Single' },
	whereto: "",
	czywaga: false,
	mag: "",
	backto: "",
	jwt: "",
	skr: 0,
	gitem: {},
        id_odpadu: 0,
   }),
   provide: {
	grid: [Page, Sort, Filter, Group]
   },
   methods: { 
	dowagiclick() {
		//alert("Przejdź do wagi");
    		let selectedrowindex = this.$refs.grid.getSelectedRowIndexes();  // Get the selected row indexes.
		var sknr = selectedrowindex[0];
                if(sknr === 0)
                var suma_skrzyn = Number(document.querySelector('#skrzynia').value);
                else
		var suma_skrzyn = Number(document.querySelector('#skrzynia' + sknr).value);

		this.$router.push({ path: "/waga" + this.whereto + "&id_skrzyni=" + this.gitem.id + "&skrzyn=" + suma_skrzyn});
	},
	wrocclick() {
		this.$router.push({ path: "" + this.backto });
	},
	rowSelected(args) {
    		let selectedrowindex = this.$refs.grid.getSelectedRowIndexes();  // Get the selected row indexes.
    		//alert(selectedrowindex); // To alert the selected row indexes.
    		let selectedrecords = this.$refs.grid.getSelectedRecords();  // Get the selected records.
		//alert(selectedrecords);
		this.selectSkrzynia(selectedrowindex);
		//console.log(selectedrowindex);
		if (selectedrowindex != null && selectedrowindex.length > 0) {
			this.show = true;
			this.czywaga = true;
			this.gitem = selectedrecords[0];
		} else {
			this.show = false;
			this.czywaga = false;
		}
		
	},
	selectSkrzynia(val1) {
		this.$root.$emit("update:skrzynia", val1);
	},
        selectSkr(val1) {
                this.skr = Number(val1);
        },
	getData() {
                return axios
                        .get(CONFIG.API_URL + this.url + this.mag + '/' + this.id_odpadu, {
                        headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                                "Accept": "application/json",
				"Authorization": "Bearer " +  this.jwt,
                        }
                        })
                        .then(response => {
                                return response.data;
                        })
                        .catch(e => {
                                alert("ERROR" + e);
                        });
        },
        allopakclick() {
		var that = this;
		this.getData2().then(data => {
                        that.data = data;
                });
	},
        getData2(){
                return axios
                        .get(CONFIG.API_URL + this.url + '/0/0', {
                        headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                                "Accept": "application/json",
				"Authorization": "Bearer " +  this.jwt,
                        }
                        })
                        .then(response => {
                                return response.data;
                        })
                        .catch(e => {
                                alert("ERROR" + e);
                        });
        },
   },
   mounted() {
	var params = this.$route.query;
        var prev = "";
	var id_dok_mag = "";
	var id_zlecenia = -1;
	var id_odpadu = -1;
	if (params["mag"]) {
		id_dok_mag = params["mag"];
		this.mag = "/" + "0";
	}
	if (params["id_zlecenia"]) {
		id_zlecenia = params["id_zlecenia"];
	}
	if (params["id_odpadu"]) {
		id_odpadu = params["id_odpadu"];
                this.id_odpadu = id_odpadu;
	}
        if (params["prev"]) {
             prev = params["prev"];
	     this.whereto = "?prev=odpadyopakowanie&mag=" + id_dok_mag + "&id_zlecenia=" + id_zlecenia + "&id_odpadu=" + id_odpadu + "&prev2=odpadypz";
	     if (prev.indexOf("magazyn") != -1) {
		this.title = "Panel główny > WYDANIE Z MAGAZYNU > Opakowanie";
		this.backto = "/wydaniezmag";
	     } else if (prev.indexOf("odpadypz") != -1) {
		this.title = "ODSORTY > ZLECENIA > ODSORTY > LISTA DOKUMENTÓW PZ > Opakowanie";
		this.backto = "/odpadypz" + "?id_zlecenia=" + id_zlecenia + "&id_odpadu=" + id_odpadu;
	     } else {
		this.title = "Panel główny > ODPADY > Odpady Opakowanie";
		this.backto = "/odpady" + "?id_zlecenia=" + id_zlecenia;
	     }
        }
	var that = this;
	Storage.loadJWT("jwt").then(resp => {
                that.jwt = resp.access_token;
                that.getData().then(data => {
                        that.data = data;
                });
        });
	document.querySelector(".wright").addEventListener('click', function() { that.dowagiclick(); } );
	document.querySelector(".wleft").addEventListener('click', function() { that.wrocclick(); } );

	document.querySelector(".do_wagi1").addEventListener('click', function() { that.selectSkr('1'); } );
        document.querySelector(".do_wagi2").addEventListener('click', function() { that.selectSkr('2'); } );
        document.querySelector(".do_wagi3").addEventListener('click', function() { that.selectSkr('3'); } );
   },
   components: {
	Skrzynia,
   }
};

</script>

<style>
  @import "../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";

.do_wagi {
        width: 100px;
        height: 50px;
}

.do_wagi1,.do_wagi2,.do_wagi3 {
        width: 50px;
        height: 50px;
        margin-right: 20px;
}


.title_left {
        text-align: left;
        width: 100%;
}
.items {
        float:none;
}
.dokpz_left {
        float: left;
        width: 50%;
        padding: 0% 2% 0% 2%;
}
.dokpz_right {
        padding: 10% 2% 0% 2%;
}
.dokpz_right2 {
        padding: 0% 2% 0% 2%;
}
.dokpz_right,.dokpz_right2 {
        float:right;
        width: 40%;
}
.dokpz_bottom {
        clear:both;
        width: 100%;
        padding: 2% 2% 0% 2%;
}
.wright {
        width: 200px;
        height: 50px;
        position:fixed;
        bottom: 10px;
        right: 10px;
        text-align: right;
        background-color: #FFFFFF;
        /*padding-top: 10px;*/
        float: right;
        margin-top: 40px;
}
.wleft {
        width: 200px;
        height: 50px;
        position:fixed;
        bottom: 10px;
        text-align: left;
        background-color: #FFFFFF;
        float: left;
        margin-top: 40px;
        /*margin-left: 400px;*/
}
.wlabel {
        width: 200px;
        height: 50px;
        position:relative;
        background-color: #FFFFFF;
}
.wbottom {
        clear:both;
}
.allopak {
	display:inline;
	width:100px;
	height:20px;
	color:blue;
	cursor: pointer;
        text-align: left;
}

</style>





// WEBPACK FOOTER //
// src/components/OdpadyOpakowanie.vue